/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mac_Already_ExistsInputs */



/**
* | output |
* | --- |
* | "The mac already exists" |
*
* @param {Mac_Already_ExistsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mac_already_exists = /** @type {((inputs?: Mac_Already_ExistsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mac_Already_ExistsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The mac already exists")
	return /** @type {LocalizedString} */ ("La mac existe déjà")
});